<template>
  <v-sheet class="mr-2 text-left">
    <v-row>
      <v-col cols="12">
        <v-btn @click="updateSections()"
            class="text-rigth mb-2 btn-create-sections" small color="primary">
            {{ $t('common.save') }}
        </v-btn>
        <div class="add-section mb-2 ml-1">
          <v-btn 
            v-if="isLapsCheckpoints"
            @click="createSection('LapCheckpoint')"
            class="text-rigth" 
            small 
            color="primary"
          >
            <i class="fas fa-plus"></i>
            {{ $t('page.sectionEditor.add_checkpoint', 1) }}
          </v-btn>
          <v-btn 
            v-else
            @click="createSection('Regular')"
            class="text-rigth" 
            small 
            color="primary"
          >
            <i class="fas fa-plus"></i>
            {{ $t('page.sectionEditor.add_new_section', 1) }}
          </v-btn>
          <v-btn
            v-if="isReliabilityEnduroAndReliability"
            @click="createSection('TimeCheck')"
            class="text-rigth ml-1"
            small
            color="primary"
          >
            <i class="fas fa-plus"></i>
            {{ $t('page.sectionEditor.add_time_check', 1) }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="mx-auto" width="100%" outlined>
        <v-expansion-panels accordion multiple hover class="pb-4" v-model="expandedPanels">
          <v-expansion-panel
            v-for="(section, index) in Sections"
            :key="`section-${index}`"
            :id="`sectionid-${index}`"   
          >
          <div v-if="shouldRenderSection(section)">
            <v-expansion-panel-header class="py-0">
              <v-container fluid class="py-0">
                <v-row>
                  <v-col class="sectionName" cols="auto">
                    {{ setHeaderSectionText(section, index) }}
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-if="Race.mode == 11 && section.sectionType == 'LapCheckpoint'">
                <SectionLapCheckPoint 
                  :ref="`sectionLapCheckPoint-${section.id}`"
                  :SelectedSection="section"
                  :RaceId="RaceId"
                />
              </div>
              
              <div v-else-if="section.sectionType == 'TimeCheck'">
                <TimeCheck 
                  :ref="`timeCheck-${section.id}`"
                  :SelectedSection="section"
                />
              </div>
              
              <div v-else-if="section.sectionType == 'Regular'">
                <SectionDetails 
                  :ref="`sectionDetails-${section.id}`"
                  :SelectedSection="section"
                  :RaceId="RaceId"
                />
              </div>
            </v-expansion-panel-content>
          </div>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>

      </v-col>
    </v-row>
    <SGSNotificationAlert v-if="errorDialog" :notificationMessage="errorDialogMessage" @cancel="errorDialog=false;" type='error'/>
  </v-sheet>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SectionDetails from "@/components/section-editor/SectionDetails.vue";
import TimeCheck from "@/components/section-editor/time-check/TimeCheck.vue";
import SectionLapCheckPoint from "@/components/section-editor/SectionLapCheckpoint.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
import { mapState } from 'vuex';
import { isArray } from 'lodash';

export default {
  mixins: [apiCalls], //for api redundant operations
  props: ["SectionIndex", "RaceId"],
  components: { SectionDetails,TimeCheck,SectionLapCheckPoint,SGSNotificationAlert },
  data() {
    return {
      sectionDetailsAPIUrl: "/api/v1/promoter/section",
      raceModes: {
        realibilityEnduro: 10
      },
      raceSubModes: {
        realibility: "reliability"
      },
      width: {
        extraSmall: {
          min:0,
          max:599
        },
        small: {
          min: 600,
          max: 960
        }
      },
      openLastSection: false,
      expandedPanels: [],
      errorDialog: false,
      errorDialogMessage: '',
    }
  },
  computed: {
		...mapState({
      openSectionIndex: state => state.sectionEditor.openSectionIndex
    }),
    Sections() {
      return this.$store.getters.getSections;
    },
    Race() {
      return this.$store.getters.getRaceSections;
    },
    isReliabilityEnduroAndReliability: function(){
      if(this.Race && this.raceModes && this.raceSubModes && this.Race.mode == this.raceModes.realibilityEnduro && this.Race.subMode == this.raceSubModes.realibility){
        return true;
      }
      return false;
    },
    SectionsUpdate() {
      return this.$store.getters.getSectionsUpdate;
    },
	isLapsCheckpoints() {
      if(this.Race) {
        return this.Race.mode == 11;
      }
      return false;
    },
    isSprint() {
      if(this.Race) {
        return this.Race.mode == 10 && this.Race.subMode == 'sprint';
    }
      return false;
    }
	},
  methods: {
    shouldRenderSection(section){
      const validSectionTypes = ['LapCheckpoint', 'TimeCheck', 'Regular']
      return validSectionTypes.includes(section.sectionType)
    },
    selectSection: function(section) {
      this.$emit("selectedSection", section);
    },
    calcCheck: function(index, type) {
      if (type == "in") {
        return index * 2 + 1;
      } else {
        return index * 2 + 2;
      }
    },
    setAccordionRegularSectionText: function(section){
      const sectionName = `${section.sectionName} `;
      const sectionChecks = section.raceSectionChecks;
      let checkNumber = (isArray(sectionChecks) && sectionChecks.length > 0) ? [sectionChecks[0].checkNumber] : [0];
      checkNumber.push((isArray(sectionChecks) && sectionChecks.length > 1) ? sectionChecks[1].checkNumber : 0);
      const shortInfo = `(${this.$t('page.sectionEditor.check')}#${checkNumber[0]}...`;
      let fullInfo = '---';
      if(section.raceSectionChecks.length > 1) {
        fullInfo = `(
                    ${this.$t('page.sectionEditor.check')}#${checkNumber[0]} ${this.$t('page.sectionEditor.keytime')}: ${section.raceSectionChecks[0].keyTime},
                    ${this.$t('page.sectionEditor.check')}#${checkNumber[1]} ${this.$t('page.sectionEditor.keytime')}: ${section.raceSectionChecks[1].keyTime}
                  )`;
      }
      
      let info =  (window.innerWidth > this.width.extraSmall.max) ? fullInfo : shortInfo;
      const keyTimeFlag = (section.raceSectionChecks.length > 0 && section.raceSectionChecks[0].keyTimeFlag == 0)? 'Off' : 'On';
      const inReaderFlag = (section.raceSectionChecks.length > 0 && section.raceSectionChecks[0].inReaderFlag == 0)? 'Off' : 'On';
      info += ` ${this.$t('page.sectionEditor.keytime')}: ${keyTimeFlag}, ${this.$t('page.sectionEditor.penalty')}: ${inReaderFlag}`

      return sectionName + info;
    },
    setAccordionTimecheckSectionText: function(section){
      const seectionType = this.$t('page.sectionEditor.timecheck');
      const sectionCheckNumber = section.raceSectionChecks[0].checkNumber ? section.raceSectionChecks[0].checkNumber : 0;
      const emptysectionName = (section.sectionName == undefined || section.sectionName == '') ? true :  false;
      const sectionName = (emptysectionName) ? '' : `${section.sectionName}, `;

      const shortInfo = (!emptysectionName) ? `(${section.sectionName}...` : `(${this.$t('page.sectionEditor.keytime')}: ${section.raceSectionChecks[0].keyTime})`;
      const fullInfo = `(${sectionName} ${this.$t('page.sectionEditor.keytime')}: ${section.raceSectionChecks[0].keyTime} )`;

      const info =  (window.innerWidth > this.width.extraSmall.max) ? fullInfo : shortInfo;

      return `${seectionType} ${sectionCheckNumber} ${info}`;
    },
    getLapCheckpointSections() {
      return (this.Sections || []).filter((item) => item.sectionType == 'LapCheckpoint');
    },
    getLapCheckpointIndex(section) {
      const lapSections = this.getLapCheckpointSections();
      return lapSections.findIndex((item) => item.id == section.id);
    },
    setAccordionLapCheckpointSectionText: function(section){
      const lapIndex = this.getLapCheckpointIndex(section);
      const lapSections = this.getLapCheckpointSections();
      const isLastLapCheckpoint = lapIndex >= 0 && lapIndex == lapSections.length - 1;
      const normalizedName = (section.sectionName || '').trim();

      if(isLastLapCheckpoint) {
        const finishLabel = this.$t('page.sectionEditor.finish');
        return normalizedName ? `${finishLabel} (${normalizedName})` : finishLabel;
      }

      const checkpointNumber = lapIndex >= 0 ? lapIndex + 1 : 1;
      const checkpointLabel = `${this.$t('page.sectionEditor.checkpoint')} #${checkpointNumber}`;
      return normalizedName ? `${checkpointLabel} (${normalizedName})` : checkpointLabel;
    },
    createSection: async function(sectionType) {
      let formData = new FormData();
      formData.append("raceId", this.RaceId);
      formData.append("sectionType", sectionType);

      const response = await this.api(
        "post",
        this.sectionDetailsAPIUrl,
        formData
      );
      
      if (response) {
        this.openLastSection = true;
        this.$store.dispatch('getSectionsAction',this.RaceId);
      }
    },
    evaluationData(data, rules) {
      let isValid = true;
      const rulesSplit = rules.split('|');
      if(rulesSplit.length > 1) {
        let isValidOr = false;
        rulesSplit.forEach((rule) => {
          isValidOr = isValidOr || this.$inputRules({ value: data }, rule);
        });
        isValid = isValid && isValidOr;
      } else {
        isValid = isValid && this.$inputRules({ value: data }, rulesSplit[0]);
      }
      return isValid;
    },
    notValidSectionCheckInNotSprint(section) {
      const checkIn = section.raceSectionChecks.find(check => check.checkType == 'in');
      const keyTime = checkIn.keyTime ?? '';
      const adjustment = checkIn.adjustment ?? '';
      const { penalties } = checkIn;
      const penaltyEarly = penalties.find(penalty => penalty.penaltyType == 'early');
      const penaltyLate = penalties.find(penalty => penalty.penaltyType == 'late');
      const firstMinute = penaltyEarly.firstMinute ?? '';
      const nextMinute = penaltyEarly.nextMinute ?? '';
      const dsqMinute = penaltyLate.dsqMinute ?? '';

      return (!this.isSprint && 
            (!(this.evaluationData(keyTime, 'filled') && this.evaluationData(keyTime, 'time')) || 
            !(this.evaluationData(adjustment, 'filled') && this.evaluationData(adjustment, 'integer')) || 
            !(this.evaluationData(firstMinute, 'filled') && this.evaluationData(firstMinute, 'integer')) || 
            !(this.evaluationData(nextMinute, 'filled') && this.evaluationData(nextMinute, 'integer')) || 
            !(this.evaluationData(dsqMinute, 'filled') && this.evaluationData(dsqMinute, 'integer'))));
    },
    notValidSectionCheckInSprint(section) {
      const checkIn = section.raceSectionChecks.find(check => check.checkType == 'in');
      const keyTimes = checkIn.keyTimes ?? [];
      const { penalties } = checkIn;
      const penaltyEarly = penalties.find(penalty => penalty.penaltyType == 'early');
      const penaltyLate = penalties.find(penalty => penalty.penaltyType == 'late');
      const firstMinute = penaltyEarly.firstMinute ?? '';
      const nextMinute = penaltyEarly.nextMinute ?? '';
      const dsqMinute = penaltyLate.dsqMinute ?? '';

      let isValidKeys = true;
      if(keyTimes.length > 0) {
        for(let key in keyTimes) {
          const keyTimeSprint = keyTimes[key];
          const { keyTime: keyTimeSprintAux, keyTimeNumber } = keyTimeSprint;
          if(
            !(this.evaluationData(keyTimeSprintAux, 'filled') && this.evaluationData(keyTimeSprintAux, 'time')) || 
            !this.evaluationData(keyTimeNumber,'filled')
          ) {
            isValidKeys = false;
            break;
          }
        }
      }

      if(!isValidKeys) return false;

      return (!isValidKeys || 
              (!(this.evaluationData(firstMinute, 'filled') && this.evaluationData(firstMinute, 'integer')) || 
              !(this.evaluationData(nextMinute, 'filled') && this.evaluationData(nextMinute, 'integer')) || 
              !(this.evaluationData(dsqMinute, 'filled') && this.evaluationData(dsqMinute, 'integer'))));
    },
    notValidSectionCheckOut(section) {
      const checkOut = section.raceSectionChecks.find(check => check.checkType == 'out');
      const keyTimeOut = checkOut.keyTime ?? '';
      const { penalties: penaltiesOut } = checkOut;
      const penaltyLateOut = penaltiesOut.find(penalty => penalty.penaltyType == 'late');
      const dsqMinuteOut = penaltyLateOut.dsqMinute ?? '';

      return (!(this.evaluationData(keyTimeOut, 'filled') && this.evaluationData(keyTimeOut, 'time')) || 
              !(this.evaluationData(dsqMinuteOut, 'filled') && this.evaluationData(dsqMinuteOut, 'integer')));
    },
    notValidSectionClasses(section) {
      let sectionClasses = section.raceSectionClass;
      let isValidClasses = true;
      if(sectionClasses.length > 0) {
        for(let i = 0; i < sectionClasses.length; i++) {
          const sectionClass = sectionClasses[i];
          const runLimitClass = sectionClass.runLimit ?? '';
          if(!(this.evaluationData(runLimitClass, 'filled') && this.evaluationData(runLimitClass, 'integer'))) {
            isValidClasses = false;
            break;
          }
        }
      }
      return !isValidClasses;
    },
    notValidSectionCheck(section) {
      const check = section.raceSectionChecks.length > 0 ? section.raceSectionChecks[0] : null;
      const keyTime = check.keyTime ?? '';
      const checkType = check.checkType ?? '';

      return (!this.evaluationData(checkType, 'filled') || 
              !(this.evaluationData(keyTime, 'filled') && this.evaluationData(keyTime, 'time')));
    },
    notValidSectionCheckPenalties(section) {
      const check = section.raceSectionChecks.length > 0 ? section.raceSectionChecks[0] : null;
      const { penalties } = check;
      const penaltyEarly = penalties.find(penalty => penalty.penaltyType == 'early');
      const penaltyLate = penalties.find(penalty => penalty.penaltyType == 'late');
      const withoutPenalty = penaltyEarly.withoutPenalty ?? '';
      const firstMinute = penaltyEarly.firstMinute ?? '';
      const nextMinute = penaltyEarly.nextMinute ?? '';
      const dsqMinute = penaltyEarly.dsqMinute ?? '';
      const withoutPenaltyLate = penaltyLate.withoutPenalty ?? '';
      const firstMinuteLate = penaltyLate.firstMinute ?? '';
      const nextMinuteLate = penaltyLate.nextMinute ?? '';
      const dsqMinuteLate = penaltyLate.dsqMinute ?? '';

      return (!(this.evaluationData(withoutPenalty, 'filled') && this.evaluationData(withoutPenalty, 'integer')) || 
            !(this.evaluationData(firstMinute, 'filled') && this.evaluationData(firstMinute, 'integer')) || 
            !(this.evaluationData(nextMinute, 'filled') && this.evaluationData(nextMinute, 'integer')) || 
            !(this.evaluationData(dsqMinute, 'filled') && this.evaluationData(dsqMinute, 'integer')) || 
            !(this.evaluationData(withoutPenaltyLate, 'filled') && this.evaluationData(withoutPenaltyLate, 'integer')) || 
            !(this.evaluationData(firstMinuteLate, 'filled') && this.evaluationData(firstMinuteLate, 'integer')) || 
            !(this.evaluationData(nextMinuteLate, 'filled') && this.evaluationData(nextMinuteLate, 'integer')) || 
            !(this.evaluationData(dsqMinuteLate, 'filled') && this.evaluationData(dsqMinuteLate, 'integer')));
    },
    validationSectionRegular(section,index) {
      let isValid = true;
      const refSectionAux = `sectionDetails-${section.id}`;
      const refSectionComponent = this.$refs[refSectionAux];
      if(refSectionComponent) {
        isValid = refSectionComponent[0].$refs.frmSectionEditor.validate();
        if(!isValid) return false;
        const refsChecks = refSectionComponent[0].$refs.sectionCheck; 
        let refSectionCheckIn = null;
        let refSectionCheckOut = null;
        if(refsChecks && refsChecks.length > 0) {
          refSectionCheckIn = refsChecks.find((el) => { 
            return el.$refs.sectionCheckIn; 
          });
          refSectionCheckIn = refSectionCheckIn ? refSectionCheckIn.$refs.sectionCheckIn : null;
          refSectionCheckOut = refsChecks.find((el) => { 
            return el.$refs.sectionCheckOut; 
          })
          refSectionCheckOut = refSectionCheckOut ? refSectionCheckOut.$refs.sectionCheckOut : null;
        }

        if(refSectionCheckIn) {
          isValid = refSectionCheckIn.$refs.formCheckIn.validate();
          if(!isValid) return false;
        } else {
          //validar 
          if(this.notValidSectionCheckInNotSprint(section)) {
            isValid = false;
            if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
            this.$nextTick(() => {
              setTimeout(() => {
                const refSectionDetails = this.$refs[refSectionAux][0];
                if(!refSectionDetails.expandedPanels.includes(0)) refSectionDetails.expandedPanels.push(0);
                this.$nextTick(() => {
                  setTimeout(() => {
                    const refSectionsCheck = refSectionDetails.$refs.sectionCheck;
                    const refSectionCheckIn = refSectionsCheck.find((el) => {
                      return el.$refs.sectionCheckIn;
                    }).$refs.sectionCheckIn;
                    refSectionCheckIn.$refs.formCheckIn.validate();
                  },10);
                });
              },10);
            });
          } else if(this.isSprint) {
            if(this.notValidSectionCheckInSprint(section)) {
              isValid = false;
              if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
              this.$nextTick(() => {
                setTimeout(() => {
                  const refSectionDetails = this.$refs[refSectionAux][0];
                  if(!refSectionDetails.expandedPanels.includes(0)) refSectionDetails.expandedPanels.push(0);
                  this.$nextTick(() => {
                    setTimeout(() => {
                      const refSectionsCheck = refSectionDetails.$refs.sectionCheck;
                      const refSectionCheckIn = refSectionsCheck.find((el) => {
                        return el.$refs.sectionCheckIn;
                      }).$refs.sectionCheckIn;
                      refSectionCheckIn.$refs.formCheckIn.validate();
                    },10);
                  });
                },10);
              });
            }
          }
          
          if(isValid) {
            if(this.notValidSectionCheckOut(section)) {
              isValid = false;
              if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
              this.$nextTick(() => {
                setTimeout(() => {
                  const refSectionDetails = this.$refs[refSectionAux][0];
                  if(!refSectionDetails.expandedPanels.includes(1)) refSectionDetails.expandedPanels.push(1);
                  this.$nextTick(() => {
                    setTimeout(() => {
                      const refSectionsCheck = refSectionDetails.$refs.sectionCheck;
                      const refSectionCheckOut = refSectionsCheck.find((el) => {
                        return el.$refs.sectionCheckOut;
                      }).$refs.sectionCheckOut; 
                      refSectionCheckOut.$refs.formCheckOut.validate();
                    },10);
                  });
                },10);
              });
            } else if(this.isSprint) {
              if(this.notValidSectionClasses(section)) {
                isValid = false;
                if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
                this.$nextTick(() => {
                  setTimeout(() => {
                    const refSectionDetails = this.$refs[refSectionAux][0];
                    if(!refSectionDetails.expandedPanels.includes(2)) refSectionDetails.expandedPanels.push(2);
                    this.$nextTick(() => {
                      setTimeout(() => {
                        const refSectionClasses = refSectionDetails.$refs.sectionClasses;
                        refSectionClasses.$refs.formClasses.validate();
                      },10);
                    });
                  },10);
                });
              }
            }
          }
          if(!isValid) return false;
        }
        
        if(refSectionCheckOut) { //console.log(refSectionCheckOut);
          isValid = refSectionCheckOut.$refs.formCheckOut.validate();
          if(!isValid) return false;
        } else {
          //validar
          if(this.notValidSectionCheckOut(section)) {
            isValid = false;
            if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
              this.$nextTick(() => {
                setTimeout(() => {
                  const refSectionDetails = this.$refs[refSectionAux][0];
                  if(!refSectionDetails.expandedPanels.includes(1)) refSectionDetails.expandedPanels.push(1);
                  this.$nextTick(() => {
                    setTimeout(() => {
                      const refSectionsCheck = refSectionDetails.$refs.sectionCheck;
                      const refSectionCheckOut = refSectionsCheck.find((el) => {
                        return el.$refs.sectionCheckOut;
                      }).$refs.sectionCheckOut; 
                      refSectionCheckOut.$refs.formCheckOut.validate();
                    },10);
                  });
                },10);
              });
          } else if(this.isSprint) {
              if(this.notValidSectionClasses(section)) {
                isValid = false;
                if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
                this.$nextTick(() => {
                  setTimeout(() => {
                    const refSectionDetails = this.$refs[refSectionAux][0];
                    if(!refSectionDetails.expandedPanels.includes(2)) refSectionDetails.expandedPanels.push(2);
                    this.$nextTick(() => {
                      setTimeout(() => {
                        const refSectionClasses = refSectionDetails.$refs.sectionClasses;
                        refSectionClasses.$refs.formClasses.validate();
                      },10);
                    });
                  },10);
                });
              }
          }
          if(!isValid) return false;
        }
        
        if(this.isSprint) {
          const refsClasses = refSectionComponent[0].$refs.sectionClasses;
          if(refsClasses) {
            isValid = refsClasses.$refs.formClasses.validate();
            if(!isValid) return false;
          } else {
            //validar campos
            if(this.notValidSectionClasses(section)) {
                isValid = false;
                if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
                this.$nextTick(() => {
                  setTimeout(() => {
                    const refSectionDetails = this.$refs[refSectionAux][0];
                    if(!refSectionDetails.expandedPanels.includes(2)) refSectionDetails.expandedPanels.push(2);
                    this.$nextTick(() => {
                      setTimeout(() => {
                        const refSectionClasses = refSectionDetails.$refs.sectionClasses;
                        refSectionClasses.$refs.formClasses.validate();
                      },10);
                    });
                  },10);
                });
            }
            if(!isValid) return false;
          }
        }
      } else {
        const sectionName = section.sectionName ?? '';
        const length = section.length ?? '';
        const measure = section.measure ?? '';
        const runLimit = section.runLimit ?? '';
        
        if(
          !this.evaluationData(sectionName, 'filled') || 
          !(this.evaluationData(length, 'filled') && this.evaluationData(length, 'integer|floatTwoDecimal')) || 
          !this.evaluationData(measure, 'filled') || 
          !(!this.isSprint || (this.isSprint && this.evaluationData(runLimit, 'filled')))
        ) {
          isValid = false;
          if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs[refSectionAux][0].$refs.frmSectionEditor.validate();
            },10);
          });
        } else {
          
          if(this.notValidSectionCheckInNotSprint(section)) {
            isValid = false;
            if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
            this.$nextTick(() => {
              setTimeout(() => {
                const refSectionDetails = this.$refs[refSectionAux][0];
                if(!refSectionDetails.expandedPanels.includes(0)) refSectionDetails.expandedPanels.push(0);
                this.$nextTick(() => {
                  setTimeout(() => {
                    const refSectionsCheck = refSectionDetails.$refs.sectionCheck;
                    const refSectionCheckIn = refSectionsCheck.find((el) => {
                      return el.$refs.sectionCheckIn;
                    }).$refs.sectionCheckIn;
                    refSectionCheckIn.$refs.formCheckIn.validate();
                  },10);
                });
              },10);
            });
          } else if(this.isSprint) {
            if(this.notValidSectionCheckInSprint(section)) {
              isValid = false;
              if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
              this.$nextTick(() => {
                setTimeout(() => {
                  const refSectionDetails = this.$refs[refSectionAux][0];
                  if(!refSectionDetails.expandedPanels.includes(0)) refSectionDetails.expandedPanels.push(0);
                  this.$nextTick(() => {
                    setTimeout(() => {
                      const refSectionsCheck = refSectionDetails.$refs.sectionCheck;
                      const refSectionCheckIn = refSectionsCheck.find((el) => {
                        return el.$refs.sectionCheckIn;
                      }).$refs.sectionCheckIn;
                      refSectionCheckIn.$refs.formCheckIn.validate();
                    },10);
                  });
                },10);
              });
            }
          }
          
          if(isValid) {
            if(this.notValidSectionCheckOut(section)) {
              isValid = false;
              if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
              this.$nextTick(() => {
                setTimeout(() => {
                  const refSectionDetails = this.$refs[refSectionAux][0];
                  if(!refSectionDetails.expandedPanels.includes(1)) refSectionDetails.expandedPanels.push(1);
                  this.$nextTick(() => {
                    setTimeout(() => {
                      const refSectionsCheck = refSectionDetails.$refs.sectionCheck;
                      const refSectionCheckOut = refSectionsCheck.find((el) => {
                        return el.$refs.sectionCheckOut;
                      }).$refs.sectionCheckOut; 
                      refSectionCheckOut.$refs.formCheckOut.validate();
                    },10);
                  });
                },10);
              });
            } else if(this.isSprint) {
              if(this.notValidSectionClasses(section)) {
                isValid = false;
                if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
                this.$nextTick(() => {
                  setTimeout(() => {
                    const refSectionDetails = this.$refs[refSectionAux][0];
                    if(!refSectionDetails.expandedPanels.includes(2)) refSectionDetails.expandedPanels.push(2);
                    this.$nextTick(() => {
                      setTimeout(() => {
                        const refSectionClasses = refSectionDetails.$refs.sectionClasses;
                        refSectionClasses.$refs.formClasses.validate();
                      },10);
                    });
                  },10);
                });
              }
            }
          }
        }
      }
      return isValid;
    },
    validationSectionTimeCheck(section,index) {
      let isValid = true;
      const refSectionAux = `timeCheck-${section.id}`;
      const refSectionComponent = this.$refs[refSectionAux];
      if(refSectionComponent) {
        const refSectionTimeCheck = refSectionComponent[0];
        isValid = refSectionTimeCheck.$refs.frmTimeCheck.validate();
        const refCheck = refSectionTimeCheck.$refs.check; 
        if(refCheck) {
            const refEarlyPenalty = refCheck.$refs.earlyPenalty;
            const refLatePenalty = refCheck.$refs.latePenalty;
            let _isValid = true;
            _isValid = refEarlyPenalty.$refs.formEarlyPenalties.validate();
            if(!_isValid) isValid = false;
            _isValid = refLatePenalty.$refs.formLatePenalties.validate();
            if(!_isValid) isValid = false;
        } else {
          if(this.notValidSectionCheck(section) || this.notValidSectionCheckPenalties(section)) {
            isValid = false;
            const refSectionTimeCheck = this.$refs[refSectionAux][0];
            if(!refSectionTimeCheck.expandedPanels.includes(0)) refSectionTimeCheck.expandedPanels.push(0);
            this.$nextTick(() => {
              setTimeout(() => {
                  refSectionTimeCheck.$refs.frmTimeCheck.validate();
                  const refCheck = refSectionTimeCheck.$refs.check;
                  const refEarlyPenalty = refCheck.$refs.earlyPenalty;
                  const refLatePenalty = refCheck.$refs.latePenalty;
                  let _isValid = true;
                  _isValid = refEarlyPenalty.$refs.formEarlyPenalties.validate();
                  if(!_isValid) isValid = false;
                  _isValid = refLatePenalty.$refs.formLatePenalties.validate();
                  if(!_isValid) isValid = false;
              },10);
            });
          }
        }
      } else {
        const sectionName = section.sectionName ?? '';
        if(!this.evaluationData(sectionName, 'filled')) {
          isValid = false;
          if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs[refSectionAux][0].$refs.frmTimeCheck.validate();
            },10);
          });
        } else {
          if(this.notValidSectionCheck(section) || this.notValidSectionCheckPenalties(section)) {
            isValid = false;
            if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
            this.$nextTick(() => {
              setTimeout(() => {
                const refSectionTimeCheck = this.$refs[refSectionAux][0];
                if(!refSectionTimeCheck.expandedPanels.includes(0)) refSectionTimeCheck.expandedPanels.push(0);
                this.$nextTick(() => {
                  setTimeout(() => {
                    refSectionTimeCheck.$refs.frmTimeCheck.validate();
                    const refCheck = refSectionTimeCheck.$refs.check;
                    const refEarlyPenalty = refCheck.$refs.earlyPenalty;
                    const refLatePenalty = refCheck.$refs.latePenalty;
                    refEarlyPenalty.$refs.formEarlyPenalties.validate();
                    refLatePenalty.$refs.formLatePenalties.validate();
                  },10);
                });
              },10);
            });
          }
        }
      }
      return isValid;
    },
    validationSectionLapCheckpoint(section, index) {
      let isValid = true;
      const refSectionAux = `sectionLapCheckPoint-${section.id}`;
      const refSectionComponent = this.$refs[refSectionAux];
      if(refSectionComponent) {
        isValid = refSectionComponent[0].$refs.frmSectionEditor.validate();
      } else {
        const sectionName = section.sectionName ?? '';
        if(!this.evaluationData(sectionName, 'filled')) {
          isValid = false;
          if(!this.expandedPanels.includes(index)) this.expandedPanels.push(index);
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs[refSectionAux][0].$refs.frmSectionEditor.validate();
            },10);
          });
        }
      }
      return isValid;
    },
    validationData() {
      let isValid = true;
      const sectionsLength = this.Sections.length;
      for(let i = 0; i < sectionsLength; i++) {
        const section = this.Sections[i];
        switch(section.sectionType) {
            case "Regular": 
              isValid = this.validationSectionRegular(section,i);
              break;
            case "TimeCheck": 
              isValid = this.validationSectionTimeCheck(section,i);
              break;
            case "LapCheckpoint": 
              isValid = this.validationSectionLapCheckpoint(section,i);
              break;
        }
        if(!isValid) break;
      }
      return isValid;
    },
    async updateSections() {
      if(this.validationData()) {
      if(this.SectionsUpdate.length > 0) {
        let data = {
          raceId: this.RaceId,
          sections: this.SectionsUpdate
        };
        const response = await this.api("put","/api/v1/promoter/section/race", data); 
        
        if(response) {
          this.$store.dispatch('getSectionsAction',this.RaceId);
          this.$store.commit('setSectionsUpdate',[]);
        }
      }
      } else {
        this.errorDialogMessage = this.$t('page.sectionEditor.errors.error_invalid_form');
        this.errorDialog = true
    }
  },
    setHeaderSectionText(section,index) {
      let title = '';
      switch(section.sectionType) {
        case "TimeCheck": 
          title = this.setAccordionTimecheckSectionText(section, index);
        break;
        case "Regular": 
          title = this.setAccordionRegularSectionText(section, index);
        break;
        case "LapCheckpoint": 
          title = this.setAccordionLapCheckpointSectionText(section);
        break;
      }
      return title;
    }
  },
  created() {},
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.pe-none {
  pointer-events: none;
}

.v-application .mr-2 {
  margin-right: 0px !important;
}

.add-section {
  float: right;
}
@media only screen and (max-width: 350px) {
  .btn-create-sections, .add-section, .add-section .v-btn {
    width: 100%;
  }
}
</style>